
import { EntityManager } from "../../cocos/scripts/plan/EntityManager";
import { PlanManager } from "../../cocosPlan";
import { IdleConstruction } from "../../cocos/scripts/state";
import { ArrangementGroup, ArrangementObject, Commands, ComponentConstants, Cylinder, EntityFactory, Events, eventsManager, Hood, HttpService, JSONImporter, JSONSerializer, KitchenTool, Listener, SavaneCookie, SceneConstants } from "@rhinov/savane-js";
import { _ASSET_TYPE, ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getAssets, getMediaUrl } from "@rhinov/asset-manager-service";

declare var toastr: any;


export class FloatBarController {

    // Joinery models, all joineries in first one and specific joineries in the others
    allJoineryModels: Array<any> = [];
    allDoorsModels: Array<any> = [];
    allDoorsDoubleModels: Array<any> = [];
    allDoorsFrontModels: Array<any> = [];
    allCupboardDoorModels: Array<any> = [];
    allGarageDoorModels: Array<any> = [];
    allWindowModels: Array<any> = [];
    allWindowDoubleModels: Array<any> = [];
    allFrenchWindowModels: Array<any> = [];
    allFrenchWindowDoubleModels: Array<any> = [];
    allPictureWindowModels: Array<any> = [];
    allFixedWindowModels: Array<any> = [];
    allCanopyModels: Array<any> = [];
    // Technical elements, all technical elements in the first one and specific technical elements in the others
    allTechElementsModels: Array<any> = [];
    allCeilingBoxModels: Array<any> = [];
    allPoleModels: Array<any> = [];
    allStoveModels: Array<any> = [];
    allFireplaceModels: Array<any> = [];
    allRadiatorModels: Array<any> = [];
    allBoilerModels: Array<any> = [];
    allAirConditionerModels: Array<any> = [];
    allWardRobeModels: Array<any> = [];
    allBeamModels: Array<any> = [];
    allSpotLightModels: Array<any> = [];
    allRosetteModels: Array<any> = [];
    allWallModels: Array<any> = [];
    allCorniceModels: Array<any> = [];
    allWallDecorationModels: Array<any> = [];

    // Points on one of the variable above
    allModelsForCurrentElement: Array<any> = [];

    // Optimization to get only the fields we want from the DB
    OPTIMIZED_DB_FIELDS: string = '&sort=created_at&fields=_id,joineryType,decoratedWallType,technicalElementType,pipeline.state,pipeline.modelState';

    deliverableId: string;
    config: any;
    isDesigner: boolean;
    saveProjectFn: CallableFunction;
    planId: number;
    disableSaveProject: boolean = true;
    downloadHullListener: Listener | null = null;
    fullscreenAsked: Listener | null = null;
    body:HTMLBodyElement = document.getElementsByTagName('body')[0];

    joineryDefaultColor: string = "" + SavaneCookie.getCookie('Rhinov-Savane-DefaultJoineryColor', '0');
    currentObjectType: string = "0";
    itemPreview: string;
    objectAssetID: string;
    assetPathLoaded = _ASSET_TYPE.JOINERIES;


    rotationAngle: number = 0;
    translateX: number = 0;
    translateY: number = 0;
    scale: number = 100;
    floorheight: number = 250;
    roomfloorheight: number = 0;
    sceneUploaded = null;//Init value used in hidden file picker
    selectionUploaded = null;
    camerasUploaded = null;
    opacityValue: number = 75;
    floorOpacityValue: number = 75;
    fullscreenListener: Listener | null = null;
    didLoadListener: Listener | null = null;
    cameraResizedListener: Listener | null = null;
    actionCountList: Listener | null = null;
    actionSaveScene: Listener | null = null;
    vectorDraw: boolean = false;
    callback: CallableFunction;

    allJoineryColors = [
        { name: 'PVC Blanc', value: 0 },
        { name: 'PVC Anthracite', value: 1 },
        { name: 'LA Métal Noir', value: 6 },
        { name: 'LA Bois Clair', value: 14 },
        { name: 'LA Bois Moyen', value: 15 },
        { name: 'LA Bois Ocre', value: 16 },
        { name: 'Bois Clair', value: 2 },
        { name: 'Bois Moyen', value: 5 },
        { name: 'Bois Foncé', value: 3 },
        { name: 'Gris Alu', value: 4 },
        { name: 'Sable', value: 7 },
        { name: 'Mineral', value: 8 },
        { name: 'Taupe', value: 9 },
        { name: 'Vert Clair (6021)', value: 10 },
        { name: 'Vert Moyen (7030)', value: 11 },
        { name: 'Bordeaux', value: 12 },
        { name: 'Bleu Cobalt (5013)', value: 13 }
    ];

    allObjects = [
        { name: 'Porte', value: 0, key: 'Rhinov-Savane-DefaultJoineryModelDoor', assetPath: _ASSET_TYPE.JOINERIES, assetType: "Door", defaultmodel: SceneConstants.DefaultJoineryType.door },
        { name: 'Porte double', value: 1, key: 'Rhinov-Savane-DefaultJoineryModelDoubleDoor', assetPath: _ASSET_TYPE.JOINERIES, assetType: "Door_Double", defaultmodel: SceneConstants.DefaultJoineryType.doubleDoor },
        { name: 'Porte coulissante', value: 2, key: 'Rhinov-Savane-DefaultJoineryModelSlidingDoor', assetPath: _ASSET_TYPE.JOINERIES, assetType: "Door", defaultmodel: SceneConstants.DefaultJoineryType.slidingDoor },
        { name: 'Porte d\'entrée', value: 3, key: 'Rhinov-Savane-DefaultJoineryModelDoorFront', assetPath: _ASSET_TYPE.JOINERIES, assetType: "Door_Front", defaultmodel: SceneConstants.DefaultJoineryType.frontDoor },
        { name: 'Porte fenêtre', value: 4, key: 'Rhinov-Savane-DefaultJoineryModelFrenchWindow', assetPath: _ASSET_TYPE.JOINERIES, assetType: "FrenchDoor", defaultmodel: SceneConstants.DefaultJoineryType.frenchWindow },
        { name: 'Porte fenêtre double', value: 5, key: 'Rhinov-Savane-DefaultJoineryModelDoubleFrenchW5ndow', assetPath: _ASSET_TYPE.JOINERIES, assetType: "FrenchDoor_Double", defaultmodel: SceneConstants.DefaultJoineryType.doubleFrenchWindow },
        { name: 'Porte de placard', value: 6, key: 'Rhinov-Savane-DefaultJoineryModelCupboardDoor', assetPath: _ASSET_TYPE.JOINERIES, assetType: "CupboardDoor", defaultmodel: SceneConstants.DefaultJoineryType.cupboardDoor },
        { name: 'Fenêtre', value: 7, key: 'Rhinov-Savane-DefaultJoineryModelWindow', assetPath: _ASSET_TYPE.JOINERIES, assetType: "Window", defaultmodel: SceneConstants.DefaultJoineryType.window },
        { name: 'Fenêtre double', value: 8, key: 'Rhinov-Savane-DefaultJoineryModelDoubleWindow', assetPath: _ASSET_TYPE.JOINERIES, assetType: "Window_Double", defaultmodel: SceneConstants.DefaultJoineryType.doubleWindow },
        { name: 'Baie vitrée', value: 9, key: 'Rhinov-Savane-DefaultJoineryModelPictureWindow', assetPath: _ASSET_TYPE.JOINERIES, assetType: "PictureWindow", defaultmodel: SceneConstants.DefaultJoineryType.pictureWindow },
        { name: 'Châssis fixe', value: 10, key: 'RHinov-Savane-DefaultJoineryModelFixedWindow', assetPath: _ASSET_TYPE.JOINERIES, assetType: "FixedWindow", defaultmodel: SceneConstants.DefaultJoineryType.fixedWindow },
        { name: 'Verrière', value: 11, key: 'Rhinov-Savane-DefaultJoineryModelCanopy', assetPath: _ASSET_TYPE.JOINERIES, assetType: "Canopy", defaultmodel: SceneConstants.DefaultJoineryType.canopy },
        { name: "Volets roulants", value: 12, key: 'Rhinov-Savane-DefaultTechnicalElementModelCeilingBox', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "CeilingBox", defaultmodel: SceneConstants.DefaultTechnicalElementType.ceilingBox },
        { name: 'Porte de garage', value: 13, key: 'Rhinov-Savane-DefaultJoineryModelGarageDoor', assetPath: _ASSET_TYPE.JOINERIES, assetType: "GarageDoor", defaultmodel: SceneConstants.DefaultJoineryType.garageDoor },
        { name: 'Radiateur', value: 14, key: 'Rhinov-Savane-DefaultTechnicalElementModelRadiator', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "Radiator", defaultmodel: SceneConstants.DefaultTechnicalElementType.radiator },
        { name: 'Climatisation', value: 15, key: 'Rhinov-Savane-DefaultTechnicalElementModelAirConditioner', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "AirConditioner", defaultmodel: SceneConstants.DefaultTechnicalElementType.airConditioner },
        { name: 'Spot lumière', value: 16, key: 'Rhinov-Savane-DefaultTechnicalElementModelSpotLight', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "Spotlight", defaultmodel: SceneConstants.DefaultTechnicalElementType.spotLight },
        { name: 'Rosace', value: 17, key: 'Rhinov-Savane-DefaultTechnicalElementModelRosette', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "Rosette", defaultmodel: SceneConstants.DefaultTechnicalElementType.rosette },
        { name: 'Poutre', value: 18, key: 'Rhinov-Savane-DefaultTechnicalElementModelBeam', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "Beam", defaultmodel: SceneConstants.DefaultTechnicalElementType.beam },
        { name: 'Cheminée', value: 19, key: 'Rhinov-Savane-DefaultTechnicalElementModelFireplace', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "Fireplace", defaultmodel: SceneConstants.DefaultTechnicalElementType.fireplace },
        { name: 'Murs spéciaux', value: 20, key: 'Rhinov-Savane-DefaultWallModel', assetPath: _ASSET_TYPE.DECORATED_WALLS, assetType: "Wall", defaultmodel: SceneConstants.DefaultWallType.balconyRail },
        { name: 'Penderie', value: 21, key: 'Rhinov-Savane-DefaultTechnicalElementModelWardRobe', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "WardRobe", defaultmodel: SceneConstants.DefaultTechnicalElementType.wardRobe },
        { name: 'Corniches', value: 22, key: 'Rhinov-Savane-DefaultCorniceModel', assetPath: _ASSET_TYPE.DECORATED_WALLS, assetType: "Cornice", defaultmodel: SceneConstants.DefaultWallType.cornice },
        { name: 'Décoration murale', value: 23, key: 'Rhinov-Savane-DefaultTechnicalElementModelWallDecoration', assetPath: _ASSET_TYPE.TECHNICAL_ELEMENTS, assetType: "WallDecoration", defaultmodel: SceneConstants.DefaultTechnicalElementType.wallDecoration }
    ];
    /*
    Rhinov-SavaneJS-DefaultTechnicalElementModelRectangularPole
    Rhinov-SavaneJS-DefaultTechnicalElementModelCircularPole
    Rhinov-SavaneJS-DefaultTechnicalElementModelStove
    Rhinov-SavaneJS-DefaultTechnicalElementModelRectangularServiceShaft
    Rhinov-SavaneJS-DefaultTechnicalElementModelCircularServiceShaft
    Rhinov-SavaneJS-DefaultTechnicalElementModelBoiler
    Rhinov-SavaneJS-DefaultTechnicalElementModelWaterSource
    Rhinov-SavaneJS-DefaultTechnicalElementModelSocketTV
    Rhinov-SavaneJS-DefaultTechnicalElementModelSwitchBoard
    Rhinov-SavaneJS-DefaultTechnicalElementModelSocketSixteen
    Rhinov-SavaneJS-DefaultTechnicalElementModelSocketThirtyTwo*/

    constructor (config: any, isDesigner: boolean, saveProjectFn: CallableFunction, planId: number, deliverableId: string, callback: CallableFunction) {
        this.deliverableId = deliverableId;
        this.config = config;
        this.isDesigner = isDesigner;
        this.saveProjectFn = saveProjectFn;
        this.planId = planId;
        this.callback = callback

        //Used to disable/enable save button (disabled when save action does nothing)
        this.downloadHullListener = eventsManager.instance.addListener('downloadHull', () => {
            if ((PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded !== undefined) {
                (PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded();
                PlanManager.getInstance().updateItemsSelected([]);
                eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
            }

            this.downloadHull();
        });
        this.fullscreenAsked = eventsManager.instance.addListener(Events.FULLSCREEN_ASKED, () => {
            this.fullscreen();
        });

        this.setBodyListener();

        this.itemPreview = getMediaUrl() +
        this.allObjects[0].assetPath +
        '/' +
        SavaneCookie.getCookie(this.allObjects[0].key, this.allObjects[0].defaultmodel) +
        '/medias/previews/preview1-sm.webp';
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            this.itemPreview = ARRMGR_CLOUDINARY_URL + SavaneCookie.getCookie(this.allObjects[0].key, this.allObjects[0].defaultmodel) + '/medias/previews/preview1-sm.webp';
        }
        this.objectAssetID = SavaneCookie.getCookie(this.allObjects[0].key, this.allObjects[0].defaultmodel);
        
        // Load all wall model info first
        getAssets(_ASSET_TYPE.DECORATED_WALLS, this.OPTIMIZED_DB_FIELDS + '&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.medias.lk=vlp', (res: any) => {
            var resources = res.data.resources;

            if (resources !== undefined && resources !== null && resources.length > 0) {
                for (var i = 0; i < resources.length; i++) {
                    switch (resources[i].decoratedWallType.name) {
                        case 'Rambarde':
                            this.allWallModels.push(resources[i]);
                            break;

                        case 'Cornice':
                            this.allCorniceModels.push(resources[i]);
                            break;
                    }
                }
            }
        });

        // Load all joinery model info first
        getAssets(_ASSET_TYPE.JOINERIES, this.OPTIMIZED_DB_FIELDS + '&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.medias.lk=vlp', (res: any) => {
            var resources = res.data.resources;

            if (resources !== undefined && resources !== null && resources.length > 0) {
                this.allJoineryModels = resources;

                for (var i = 0; i < resources.length; i++) {
                    switch (resources[i].joineryType.name) {
                        case 'Door':
                            this.allDoorsModels.push(resources[i]);
                            break;

                        case 'Door_Double':
                            this.allDoorsDoubleModels.push(resources[i]);
                            break;

                        case 'Door_Front':
                            this.allDoorsFrontModels.push(resources[i]);
                            break;

                        case 'Cupboard_Door':
                            this.allCupboardDoorModels.push(resources[i]);
                            break;

                        case 'Garage_Door':
                            this.allGarageDoorModels.push(resources[i]);
                            break;

                        case 'Window':
                            this.allWindowModels.push(resources[i]);
                            break;

                        case 'Window_Double':
                            this.allWindowDoubleModels.push(resources[i]);
                            break;

                        case 'French_Window':
                            this.allFrenchWindowModels.push(resources[i]);
                            break;

                        case 'French_Window_Double':
                            this.allFrenchWindowDoubleModels.push(resources[i]);
                            break;

                        case 'Picture_Window':
                            this.allPictureWindowModels.push(resources[i]);
                            break;

                        case 'Fixed_Window':
                            this.allFixedWindowModels.push(resources[i]);
                            break;

                        case 'Canopy':
                            this.allCanopyModels.push(resources[i]);
                            break;
                    }
                }

                this.allModelsForCurrentElement = this.allDoorsModels;
                this.callback()
            }
        });

        // Load all technical elements models first
        getAssets(_ASSET_TYPE.TECHNICAL_ELEMENTS, this.OPTIMIZED_DB_FIELDS + '&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.medias.lk=vlp', (res: any) => {
            var resources = res.data.resources;

            if (resources !== undefined && resources !== null && resources.length > 0) {
                this.allTechElementsModels = resources;

                for (var i = 0; i < resources.length; i++) {
                    switch (resources[i].technicalElementType.name) {
                        case 'ceilingBox':
                            this.allCeilingBoxModels.push(resources[i]);
                            break;

                        case 'circularPole':
                        case 'rectangularPole':
                            this.allPoleModels.push(resources[i]);
                            break;

                        case 'stove':
                            this.allStoveModels.push(resources[i]);
                            break;

                        case 'fireplace':
                            this.allFireplaceModels.push(resources[i]);
                            break;

                        case 'radiator':
                            this.allRadiatorModels.push(resources[i]);
                            break;

                        case 'boiler':
                            this.allBoilerModels.push(resources[i]);
                            break;

                        case 'air-conditioner':
                            this.allAirConditionerModels.push(resources[i]);
                            break;

                        case 'wardRobe':
                            this.allWardRobeModels.push(resources[i]);
                            break;

                        case 'beam':
                            this.allBeamModels.push(resources[i]);
                            break;

                        case 'spotLight':
                            this.allSpotLightModels.push(resources[i]);
                            break;

                        case 'Rosette':
                            this.allRosetteModels.push(resources[i]);
                            break;

                        case 'wallDecoration':
                            this.allWallDecorationModels.push(resources[i]);
                            break;
                    }
                }
            }
        });

        // Project transformations
        
        this.fullscreenListener = eventsManager.instance.addListener(Events.FULLSCREEN_CHANGED, () => {
            this.resizeCallback();
        });

        //Init
        this.didLoadListener = eventsManager.instance.addListener(Events.PROJECT_DID_LOAD, () => {
            this.resizeCallback();
            return Events.UNREGISTER;
        });
        // angular.element($window).on('resize', this.resizeCallback);

        
        this.cameraResizedListener = eventsManager.instance.addListener(Events.CAMERA_RESIZED, () => {
            this.resizeCallback();
        });

        this.actionCountList = eventsManager.instance.addListener(Events.ACTIONS_COUNT_CHANGE, (event: any) => {
            this.disableSaveProjectFn(event.userData);
        });

        this.actionSaveScene = eventsManager.instance.addListener(Events.SAVE_SCENE, () => {
            this.exportRhinovFormat();
        });
    };


    setBodyListener() {
        this.body.addEventListener("fullscreenchange", () => {
            setTimeout(() => {
                eventsManager.instance.dispatch(Events.FULLSCREEN_CHANGED, !!document.fullscreenElement);
            });
        });
        this.body.addEventListener("mozfullscreenchange", () => {
            setTimeout(() => {
                eventsManager.instance.dispatch(Events.FULLSCREEN_CHANGED, !!document.fullscreenElement);
            });
        });
        this.body.addEventListener("webkitfullscreenchange", () => {
            setTimeout(() => {
                eventsManager.instance.dispatch(Events.FULLSCREEN_CHANGED, !!document.fullscreenElement);
            });
        });
        this.body.addEventListener("msfullscreenchange", () => {
            setTimeout(() => {
                eventsManager.instance.dispatch(Events.FULLSCREEN_CHANGED, !!document.fullscreenElement);
            });
        });
    }

    static getConfig(urlconfig: string, callback: CallableFunction) {
        if (urlconfig && urlconfig !== null) {
            HttpService.get(urlconfig)
                .then(
                    function(response) {
                        if (response.status === 200) {
                                callback(response.data);   
                        }
                    },
                    function(error) {
                        callback({
                            'save': false,
                            'floors': true,
                            'undo_redo': true,
                            'transformations': true,
                            'zoom': true,
                            'display_options': true,
                            'customs': [
                                {
                                    "icon": "material-icons icon-FloatBar_Help",
                                    "event": "startTuto",
                                    "for_designer": false,
                                },
                                {
                                    "icon": "fa-solid fa-chess-rook",
                                    "event": "downloadHull",
                                    "for_designer": true
                                }
                            ]
                        });
                        console.error('Can\'t find floating bar config file' + error);
                    }
                );
        } else {
            callback ({
                'save': false,
                'floors': true,
                'undo_redo': true,
                'transformations': true,
                'zoom': true,
                'display_options': true,
                'customs': []
            });
        }
    }

    getMustShowGrid(): boolean {
        return(PlanManager.getInstance().mustShowGrid);
    };

    getMustShowArea(): boolean {
        return(PlanManager.getInstance().mustShowRoomArea);
    };

    getMustShowPlan(): boolean {
        return(PlanManager.getInstance().mustShowPlan);
    };

    /**
     * Retreive rhinov format and sent it using exposed fun
     */
    exportRhinovFormat() {
        if ((PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded !== undefined) {
            (PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded();
            PlanManager.getInstance().updateItemsSelected([]);
            eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
        }

        //Use exposed func to send datas
        this.saveProjectFn(function(isSaved: boolean) {
            if (isSaved) {
                //The project has been saved
                //Reset action counter and lock save button
                PlanManager.getInstance().setActionCount(0);
                PlanManager.getInstance().setFunctionalitesActionCount(0);
            }
        });
    };

    

    downloadHull() {
        var content = KitchenTool.VersionHandler.toHullFormat(JSONSerializer.serializeEntity(PlanManager.getInstance().world.currentScene!));

        // var x_api_key = $http.defaults.headers.common['x-api-key'];
        // delete $http.defaults.headers.common['x-api-key'];

        (HttpService as any).post('https://smart.rhinov.fr/rise/designer/',
            {
                id: this.deliverableId ? parseInt(this.deliverableId) : -1,  //is this usefull
                rhinov_format: content
            },
            {
                headers: {
                    "Content-Type": 'application/json',
                    "Authorization": undefined
                },
                timeout: 60000
            }).then((response: any) => {
                if (response.status === 200){
                    var blob = new Blob([response.data.obj], { type: 'text/plain;charset=utf-8;' });
                    var downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(blob);
                    downloadLink.download = `hull.obj`;
                    downloadLink.click();
                } else {
                    toastr.error('Erreur lors de la récupération de la coque.');
                }
            }, (_response: any) => {
                toastr.error('Erreur lors de la récupération de la coque.');
            });

        // if (x_api_key !== undefined) {
        //     $http.defaults.headers.common['x-api-key'] = x_api_key;
        // }
    };

    //FLOATING BAR EVENTS SENDING
    sendEvent(event: string) {
        eventsManager.instance.dispatch(event, null);
    };

    disableSaveProjectFn(value: boolean) {
        if (this.disableSaveProject !== value) {
            this.disableSaveProject = value;
            this.callback();
        }
    };

    undo() {
        eventsManager.instance.dispatch(Events.UNDO_EVENT);
    };

    redo() {
        eventsManager.instance.dispatch(Events.REDO_EVENT);
    };

    zoomOUT() {
        eventsManager.instance.dispatch(Events.ZOOM_OUT_EVENT);
    };

    fullscreen() {
        if (document.fullscreenElement) {
            let calls = ['exitFullscreen', 'webkitExitFullscreen', 'mozCancelFullScreen', 'msExitFullscreen'];
            for (var i = 0; i < calls.length; i++) {
                if ((document as any)[calls[i]]) {
                    (document as any)[calls[i]]();
                    break;
                }
            }
        } else {
            let elem = document.getElementsByTagName('body')[0];
            let calls = ['requestFullScreen', 'webkitRequestFullScreen', 'mozRequestFullScreen', 'msRequestFullscreen'];

            for (var i = 0; i < calls.length; i++) {
                if ((elem as any)[calls[i]]) {
                    (elem as any)[calls[i]]();
                    break;
                }
            }
        }
    };


    initSettings() {
        this.vectorDraw = PlanManager.getInstance().vectorDraw;
        this.opacityValue = PlanManager.getInstance().opacity;
        this.floorOpacityValue = PlanManager.getInstance().opacityFloors;
    };

    changeVectorDraw(value: boolean) {
        PlanManager.getInstance().vectorDraw = value;
    }

    changeOpacity(value: number) {
        PlanManager.getInstance().opacity = value;
    };

    changeOpacityFloors(value: number) {
        PlanManager.getInstance().opacityFloors = value;

        for (var i = 0; i < PlanManager.getInstance().world.currentScene!.floors.length; i++) {
            var floor = PlanManager.getInstance().world.currentScene!.floors[i];
            for (var j = 0; j < floor.walls.length; j++) {
                var wallNode = EntityManager.getInstance().getNode(floor.walls[j]);

                if (wallNode !== null) {
                    // Force the wall node to redraw
                    wallNode.needRedraw = true;
                }
            }
        }
    };

    updateJoineryDefaultColor(value: number) {
        SavaneCookie.setCookie('Rhinov-Savane-DefaultJoineryColor', '' + value);
    };

    updateObjectType = (value: number) => {
        this.currentObjectType = value.toString();
        this.itemPreview = getMediaUrl() +
            this.allObjects[parseInt(this.currentObjectType)].assetPath +
            '/' +
            SavaneCookie.getCookie(this.allObjects[parseInt(this.currentObjectType)].key, this.allObjects[parseInt(this.currentObjectType)].defaultmodel) +
            '/medias/previews/preview1-sm.webp';
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            this.itemPreview = ARRMGR_CLOUDINARY_URL + SavaneCookie.getCookie(this.allObjects[parseInt(this.currentObjectType)].key, this.allObjects[parseInt(this.currentObjectType)].defaultmodel) +
            '/medias/previews/preview1-sm.webp';
        }
        this.objectAssetID = SavaneCookie.getCookie(this.allObjects[parseInt(this.currentObjectType)].key, this.allObjects[parseInt(this.currentObjectType)].defaultmodel);

        this.assetPathLoaded = this.allObjects[parseInt(this.currentObjectType)].assetPath;

        switch (this.allObjects[parseInt(this.currentObjectType)].assetType) {
            case 'Door':
                this.allModelsForCurrentElement = this.allDoorsModels;
                break;

            case 'Door_Double':
                this.allModelsForCurrentElement = this.allDoorsDoubleModels;
                break;

            case 'Door_Front':
                this.allModelsForCurrentElement = this.allDoorsFrontModels;
                break;

            case 'FrenchDoor':
                this.allModelsForCurrentElement = this.allFrenchWindowModels;
                break;

            case 'FrenchDoor_Double':
                this.allModelsForCurrentElement = this.allFrenchWindowDoubleModels;
                break;

            case 'CupboardDoor':
                this.allModelsForCurrentElement = this.allCupboardDoorModels;
                break;

            case 'Window':
                this.allModelsForCurrentElement = this.allWindowModels;
                break;

            case 'Window_Double':
                this.allModelsForCurrentElement = this.allWindowDoubleModels;
                break;

            case 'PictureWindow':
                this.allModelsForCurrentElement = this.allPictureWindowModels;
                break;

            case 'FixedWindow':
                this.allModelsForCurrentElement = this.allFixedWindowModels;
                break;

            case 'Canopy':
                this.allModelsForCurrentElement = this.allCanopyModels;
                break;

            case 'CeilingBox':
                this.allModelsForCurrentElement = this.allCeilingBoxModels;
                break;

            case 'GarageDoor':
                this.allModelsForCurrentElement = this.allGarageDoorModels;
                break;

            case 'Radiator':
                this.allModelsForCurrentElement = this.allRadiatorModels;
                break;

            case 'AirConditioner':
                this.allModelsForCurrentElement = this.allAirConditionerModels;
                break;

            case 'Fireplace':
                this.allModelsForCurrentElement = this.allFireplaceModels;
                break;

            case 'WardRobe':
                this.allModelsForCurrentElement = this.allWardRobeModels;
                break;

            case 'Beam':
                this.allModelsForCurrentElement = this.allBeamModels;
                break;

            case 'Spotlight':
                this.allModelsForCurrentElement = this.allSpotLightModels;
                break;

            case 'Rosette':
                this.allModelsForCurrentElement = this.allRosetteModels;
                break;

            case 'Wall':
                this.allModelsForCurrentElement = this.allWallModels;
                break;

            case 'Cornice':
                this.allModelsForCurrentElement = this.allCorniceModels;
                break;

            case 'WallDecoration':
                this.allModelsForCurrentElement = this.allWallDecorationModels;
                break;

            default:
                if (this.allObjects[parseInt(this.currentObjectType)].assetPath === _ASSET_TYPE.JOINERIES) {
                    this.allModelsForCurrentElement = this.allJoineryModels;
                }
                else {
                    this.allModelsForCurrentElement = this.allTechElementsModels;
                }

        }
    };

    addGeometryPrimitivs(type: string) {
        switch(type) {
            case "box":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.box, 500);
                geomPrim.width = 500;
                geomPrim.length = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "cylinder":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.cylinder, 500);
                (geomPrim as Cylinder).diameter = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "triangle":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.triangle, 500);
                geomPrim.width = 500;
                geomPrim.length = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "oval":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.oval, 500);
                geomPrim.width = 250;
                geomPrim.length = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "sphere":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.sphere, 500);
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "hood":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.hood, 1500);
                geomPrim.width = 500;
                geomPrim.length = 1000;
                (geomPrim as Hood).topWidth = 300;
                (geomPrim as Hood).topLength = 750;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "halfarc":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.halfarc, 500);
                geomPrim.width = 500;
                geomPrim.length = 500;
                (geomPrim as any).diameter = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;
        }

    }

    setObjectAssetID() {
        SavaneCookie.setCookie(this.allObjects[parseInt(this.currentObjectType)].key, this.objectAssetID);
        this.itemPreview = getMediaUrl() +
            this.allObjects[parseInt(this.currentObjectType)].assetPath +
            '/' +
            SavaneCookie.getCookie(this.allObjects[parseInt(this.currentObjectType)].key, this.allObjects[parseInt(this.currentObjectType)].defaultmodel) +
            '/medias/previews/preview1-sm.webp';
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            this.itemPreview = ARRMGR_CLOUDINARY_URL + SavaneCookie.getCookie(this.allObjects[parseInt(this.currentObjectType)].key, this.allObjects[parseInt(this.currentObjectType)].defaultmodel) +
            '/medias/previews/preview1-sm.webp';
        }
    };

    getPreviewUrl(modele: any): string {
        var url = getMediaUrl() +
            this.assetPathLoaded +
            '/' +
            modele._id +
            '/medias/previews/preview1-sm.webp';
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            url = ARRMGR_CLOUDINARY_URL + modele._id + '/medias/previews/preview1-sm.webp';
        }

        return (url);
    };

    updateModeleType(modele: any) {
        this.objectAssetID = modele._id;
        this.setObjectAssetID();
    };

    doApplyJoineryColor(color: number, indoor: boolean) {
        eventsManager.instance.dispatch(Events.DO_APPLYJOINERY_COLOR, { color: color, indoor: indoor });
    };

    doRotateProject() {
        eventsManager.instance.dispatch(Events.DO_PROJECT_ROTATION, this.rotationAngle);
    };

    changeRotationAngleProject(rotationAngle: number) {
        this.rotationAngle = rotationAngle;
    };

    doSymetryProject(axis: string) {
        eventsManager.instance.dispatch(Events.DO_PROJECT_SYMETRY, axis);
    };

    doTranslateProject() {
        eventsManager.instance.dispatch(Events.DO_PROJECT_TRANSLATION, { translateX: this.translateX * 10, translateY: this.translateY * 10 });
    };

    changeTranslateXProject(translateX: number) {
        this.translateX = translateX;
    };

    changeTranslateYProject(translateY: number) {
        this.translateY = translateY;
    };

    doScaleProject() {
        eventsManager.instance.dispatch(Events.DO_PROJECT_SCALE, this.scale);
    };

    changeScaleProject(scale: number) {
        this.scale = scale;
    };

    doSetFloorHeight() {
        eventsManager.instance.dispatch(Events.DO_SET_FLOOR_HEIGHT, this.floorheight * 10);
    };

    doSetProjectFloorHeight() {
        eventsManager.instance.dispatch(Events.DO_SET_PROJECT_FLOOR_HEIGHT, this.floorheight * 10);
    };

    changeFloorHeight(floorheight: number) {
        this.floorheight = floorheight;
    };

    doSetRoomFloorHeight() {
        eventsManager.instance.dispatch(Events.DO_SET_ROOM_FLOOR_HEIGHT, this.roomfloorheight * 10);
    };

    changeRoomFloorHeight(roomfloorheight: number) {
        this.roomfloorheight = roomfloorheight;
    };

    doSetFloorCornices(activate: boolean) {
        eventsManager.instance.dispatch(Events.DO_SET_FLOOR_CORNICES, activate);
    };

    doSetProjectCornices(activate: boolean) {
        eventsManager.instance.dispatch(Events.DO_SET_PROJECT_CORNICES, activate);
    };

    doResetDefaultModels() {
        for (var i = 0; i < this.allObjects.length; i++) {
            SavaneCookie.setCookie(this.allObjects[i].key, this.allObjects[i].defaultmodel);
        }
        this.updateObjectType(Number(this.currentObjectType));
    };

    zoomIN() {
        eventsManager.instance.dispatch(Events.ZOOM_IN_EVENT);
    };

    dispGrid() {
        PlanManager.getInstance().mustShowGrid = !PlanManager.getInstance().mustShowGrid;
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, PlanManager.getInstance().mustShowGrid);
    };
    dispArea() {
        PlanManager.getInstance().mustShowRoomArea = !PlanManager.getInstance().mustShowRoomArea;
        eventsManager.instance.dispatch(Events.TOGGLE_ROOM_AREA, PlanManager.getInstance().mustShowRoomArea);
    };
    dispPlan() {
        PlanManager.getInstance().mustShowPlan = !PlanManager.getInstance().mustShowPlan;
        eventsManager.instance.dispatch(Events.TOGGLE_PLAN, PlanManager.getInstance().mustShowPlan);
    };
    dispCamera() {
        PlanManager.getInstance().mustShowCamera = !PlanManager.getInstance().mustShowCamera;
        eventsManager.instance.dispatch(Events.TOGGLE_USER_PICTURES, PlanManager.getInstance().mustShowCamera);
    };
    
    /**
        * Simulate click on the file picker to download local files
        */
    importRhinovFormat() {
        (document.getElementById('format-rhinov-pick') as HTMLInputElement).value = '';
        document.getElementById('format-rhinov-pick')!.click();
    };

    /**
        * Watch if a file has been selected in the hidden file picker
        */
    CheckSceneUploaded(newValue: File) {
        if (newValue !== null) {
            var currentRhinovScene = PlanManager.getInstance().world;
            var currentActiveDrawTime = currentRhinovScene._activeDrawTime;
            var currentIdleDrawTime = currentRhinovScene._idleDrawTime;
            var currentIdleDrawDurations = currentRhinovScene._idleDrawDurations;

            var currentActiveDrawCRTime = currentRhinovScene._activeDrawCRTime;
            var currentIdleDrawCRTime = currentRhinovScene._idleDrawCRTime;
            var currentIdleDrawCRDurations = currentRhinovScene._idleDrawCRDurations;

            var currentActiveDrawCRVisioTime = currentRhinovScene._activeDrawCRVisioTime;
            var currentIdleDrawCRVisioTime = currentRhinovScene._idleDrawCRVisioTime;
            var currentIdleDrawCRVisioDurations = currentRhinovScene._idleDrawCRVisioDurations;

            var currentActiveConstructionTime = currentRhinovScene._activeConstructionTime;
            var currentIdleConstructionTime = currentRhinovScene._idleConstructionTime;
            var currentIdleConstructionDurations = currentRhinovScene._idleConstructionDurations;

            var currentActiveConstructionCRTime = currentRhinovScene._activeConstructionCRTime;
            var currentIdleConstructionCRTime = currentRhinovScene._idleConstructionCRTime;
            var currentIdleConstructionCRDurations = currentRhinovScene._idleConstructionCRDurations;

            var currentActiveConstructionCRVisioTime = currentRhinovScene._activeConstructionCRVisioTime;
            var currentIdleConstructionCRVisioTime = currentRhinovScene._idleConstructionCRVisioTime;
            var currentIdleConstructionCRVisioDurations = currentRhinovScene._idleConstructionCRVisioDurations;

            var currentActiveDecorationTime = currentRhinovScene._activeDecorationTime;
            var currentIdleDecorationTime = currentRhinovScene._idleDecorationTime;
            var currentIdleDecorationDurations = currentRhinovScene._idleDecorationDurations;

            var currentActiveDecorationCRTime = currentRhinovScene._activeDecorationCRTime;
            var currentIdleDecorationCRTime = currentRhinovScene._idleDecorationCRTime;
            var currentIdleDecorationCRDurations = currentRhinovScene._idleDecorationCRDurations;

            var currentActiveDecorationCRVisioTime = currentRhinovScene._activeDecorationCRVisioTime;
            var currentIdleDecorationCRVisioTime = currentRhinovScene._idleDecorationCRVisioTime;
            var currentIdleDecorationCRVisioDurations = currentRhinovScene._idleDecorationCRVisioDurations;

            var currentLogActiveTime = currentRhinovScene._logActiveTime;
            var currentLogIdleTime = currentRhinovScene._logIdleTime;

            var currentNbAMRequests = currentRhinovScene._nbAMRequests;
            var currentTotalTimeAMRequests = currentRhinovScene._totalTimeAMRequests;
            var currentMinTimeAMRequests = currentRhinovScene._minTimeAMRequests;
            var currentMaxTimeAMRequests = currentRhinovScene._maxTimeAMRequests;
            var currentNbStaticHullRequests = currentRhinovScene._nbStaticHullRequests;
            var currentTotalTimeStaticHullRequests = currentRhinovScene._totalTimeStaticHullRequests;
            var currentNbDynamicHullRequests = currentRhinovScene._nbDynamicHullRequests;
            var currentTotalTimeDynamicHullRequests = currentRhinovScene._totalTimeDynamicHullRequests;
            var currentNbFloorHullRequests = currentRhinovScene._nbFloorHullRequests;
            var currentTotalTimeFloorHullRequests = currentRhinovScene._totalTimeFloorHullRequests;

            EntityFactory.getInstance().setLastEntityId(-1);

            var r = new FileReader();
            r.onload = function(e) {
                //FIXME do something here to pass plan to cocos and notifiy related UI
                eventsManager.instance.dispatch(Events.UPDATE_RHINOV_FORMAT, JSON.parse((e as any).target!.result!.toString()));
                //this.rhinovFormat = JSON.parse(e.target.result);
                KitchenTool.KitchenManager.setFurnitureFinishes(PlanManager.getInstance().world.currentScene!.currentFloor);
                eventsManager.instance.dispatch(Events.PROJECT_RELOAD);
                eventsManager.instance.dispatch("CHANGE_DESIGNER_APP_TITLE", (newValue as any).path);

                currentRhinovScene = PlanManager.getInstance().world;
                currentRhinovScene._activeDrawTime = currentActiveDrawTime;
                currentRhinovScene._idleDrawTime = currentIdleDrawTime;
                currentRhinovScene._idleDrawDurations = currentIdleDrawDurations;

                currentRhinovScene._activeDrawCRTime = currentActiveDrawCRTime;
                currentRhinovScene._idleDrawCRTime = currentIdleDrawCRTime;
                currentRhinovScene._idleDrawCRDurations = currentIdleDrawCRDurations;

                currentRhinovScene._activeDrawCRVisioTime = currentActiveDrawCRVisioTime;
                currentRhinovScene._idleDrawCRVisioTime = currentIdleDrawCRVisioTime;
                currentRhinovScene._idleDrawCRVisioDurations = currentIdleDrawCRVisioDurations;

                currentRhinovScene._activeConstructionTime = currentActiveConstructionTime;
                currentRhinovScene._idleConstructionTime = currentIdleConstructionTime;
                currentRhinovScene._idleConstructionDurations = currentIdleConstructionDurations;

                currentRhinovScene._activeConstructionCRTime = currentActiveConstructionCRTime;
                currentRhinovScene._idleConstructionCRTime = currentIdleConstructionCRTime;
                currentRhinovScene._idleConstructionCRDurations = currentIdleConstructionCRDurations;

                currentRhinovScene._activeConstructionCRVisioTime = currentActiveConstructionCRVisioTime;
                currentRhinovScene._idleConstructionCRVisioTime = currentIdleConstructionCRVisioTime;
                currentRhinovScene._idleConstructionCRVisioDurations = currentIdleConstructionCRVisioDurations;

                currentRhinovScene._activeDecorationTime = currentActiveDecorationTime;
                currentRhinovScene._idleDecorationTime = currentIdleDecorationTime;
                currentRhinovScene._idleDecorationDurations = currentIdleDecorationDurations;

                currentRhinovScene._activeDecorationCRTime = currentActiveDecorationCRTime;
                currentRhinovScene._idleDecorationCRTime = currentIdleDecorationCRTime;
                currentRhinovScene._idleDecorationCRDurations = currentIdleDecorationCRDurations;

                currentRhinovScene._activeDecorationCRVisioTime = currentActiveDecorationCRVisioTime;
                currentRhinovScene._idleDecorationCRVisioTime = currentIdleDecorationCRVisioTime;
                currentRhinovScene._idleDecorationCRVisioDurations = currentIdleDecorationCRVisioDurations;

                currentRhinovScene._logActiveTime = currentLogActiveTime;
                currentRhinovScene._logIdleTime = currentLogIdleTime;

                currentRhinovScene._nbAMRequests = currentNbAMRequests;
                currentRhinovScene._totalTimeAMRequests = currentTotalTimeAMRequests;
                currentRhinovScene._minTimeAMRequests = currentMinTimeAMRequests;
                currentRhinovScene._maxTimeAMRequests = currentMaxTimeAMRequests;
                currentRhinovScene._nbStaticHullRequests = currentNbStaticHullRequests;
                currentRhinovScene._totalTimeStaticHullRequests = currentTotalTimeStaticHullRequests;
                currentRhinovScene._nbDynamicHullRequests = currentNbDynamicHullRequests;
                currentRhinovScene._totalTimeDynamicHullRequests = currentTotalTimeDynamicHullRequests;
                currentRhinovScene._nbFloorHullRequests = currentNbFloorHullRequests;
                currentRhinovScene._totalTimeFloorHullRequests = currentTotalTimeFloorHullRequests;
            };
            r.readAsText(newValue);
        }
    };
    /**
        * Start download of current plan
        */
    downloadRhinovFormat() {
        if ((PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded !== undefined) {
            (PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded();
            PlanManager.getInstance().updateItemsSelected([]);
            eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
        }

        //Export format and download it
        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST);
        var json = JSON.stringify(JSONSerializer.serializeEntity(PlanManager.getInstance().world));
        var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
        var downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'deliverable_full_' + this.planId + '.rhinov';
        downloadLink.click();
    };

    /**
        * Start download of current plan
        */
    downloadRhinovFormatWithoutDeco() {
        if ((PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded !== undefined) {
            (PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded();
            PlanManager.getInstance().updateItemsSelected([]);
            eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
        }

        //Export format and download it
        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST);
        var json = JSON.stringify(JSONSerializer.serializeEntityWithFilters(PlanManager.getInstance().world,
            [SceneConstants.EntityType.ArrangementObject, SceneConstants.EntityType.ArrangementGroup,
            SceneConstants.EntityType.RenderCamera,
            SceneConstants.EntityType.WorkTop],
            [ComponentConstants.ComponentType.CoatingArea], false));

        var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
        var downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'deliverable_withoutdeco_' + this.planId + '.rhinov';
        downloadLink.click();
    };

    /**
    * Start download of current plan
    */
    downloadRhinovFormatWithoutDecoWithKitchen() {
        if ((PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded !== undefined) {
            (PlanManager.getInstance().state as unknown as IdleConstruction).actionEditEnded();
            PlanManager.getInstance().updateItemsSelected([]);
            eventsManager.instance.dispatch(Events.HIDE_TULIP, null);
        }

        //Export format and download it
        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST);
        var json = JSON.stringify(JSONSerializer.serializeEntityWithFiltersAndObjectTypes(PlanManager.getInstance().world,
            [SceneConstants.EntityType.RenderCamera],
            [ComponentConstants.ComponentType.CoatingArea],
            ['57dbf17bc292672a7def4724', '5c34c11ef48dcd380728545c', '5c34c0cc96634b38261ca95d', '57dbf191c292672a7def4725', '585809052424b106b566ef92', '58c129d9178b09562a342ff9', '5c34cbb8a24b85380cc236bb','5c34c1435c1a73382bc54c5e','5c34c0aaa24b85380cc236b5',
            '5c34c7ecf48dcd3807285466','5c34c0ed96634b38261ca95f','5c34c11ef48dcd380728545c','58c129d9178b09562a342ff9','5c34c15f40a01538237a4569','58bfe35826a00f3d9dfecb5b','5d00daa0b846d52308a350e4']));

        var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
        var downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'deliverable_withoutdeco_withkitchen_' + this.planId + '.rhinov';
        downloadLink.click();
    };

    /**
        * Start download of floor cameras
        */
    downloadRhinovFormatCameras() {
        var i;

        var cameras = PlanManager.getInstance().world.currentScene!.currentFloor!.renderCameras;
        var cameras = cameras.sort((a, b) => a.cameraNb - b.cameraNb);
        if (cameras.length > 0) {
            var json = '[';

            for (i = 0; i < cameras.length; i++) {
                json += JSON.stringify(JSONSerializer._serializeEntity(cameras[i], [], [], []));
                if (i !== cameras.length - 1) {
                    json += ',';
                }
            }
            json += ']';

            var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
                        var downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = 'deliverable_withcameras_' + this.planId + '.rhinovcameras';
            downloadLink.click();
        }
    };

    importRhinovFormatCameras() {
        (document.getElementById('format-rhinovcameras-pick') as HTMLInputElement).value = '';
        document.getElementById('format-rhinovcameras-pick')!.click();
    };

    CheckCamerasUploaded(newValue: File) {
        if (newValue !== null) {
            var r = new FileReader();
            r.onload = (e: any) => {
                var selectionJSON = JSON.parse(e.target.result);

                for (var i = 0; i < selectionJSON.length; i++) {
                    this.updateIds(selectionJSON[i]);

                    var arr = JSONImporter.importEntity(selectionJSON[i], PlanManager.getInstance().world.currentScene!.currentFloor);

                    EntityManager.getInstance().addEntity(arr);

                    if (arr.isRenderCameraEntity()) {
                        arr.updateCameraNb(arr.world);
                    }

                    // Inform WebGL to update this object by adding it back to the scene
                    eventsManager.instance.dispatch(Events.COMMAND_EXECUTED,
                        {
                            name: Commands.CommandEnum.AddEntityCommand,
                            undo: false,
                            datas: {
                                id: arr.id,
                                type: arr.entityType,
                                entity: arr
                            }
                        });
                }
                // Then save in cache
                PlanManager.getInstance().saveInCache();
            };
            r.readAsText(newValue);
        }
    };

    /**
        * Start download of current selection
        */
    downloadRhinovFormatSelection() {
        var i: number;

        //Export format and download it
        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST);
        var selection = PlanManager.getInstance().selectedEntities;
        if (selection.length > 0) {
            var json = '[';

            for (i = 0; i < selection.length; i++) {
                json += JSON.stringify(JSONSerializer._serializeEntity(selection[i], [], [], []));
                if (i !== selection.length - 1) {
                    json += ',';
                }
            }
            json += ']';

            var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
            var downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = 'deliverable_selection_' + this.planId + '.rhinovselection';
            downloadLink.click();
        }
    };

    /**
        * Start download of current selection
        */
    downloadRhinovFormatSelectionWithoutSwitch() {
        var i: number;

        //Export format and download it
        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST);
        var selection = PlanManager.getInstance().selectedEntities;
        if (selection.length > 0) {
            var json = '[';
            var oneWritten = false;

            for (i = 0; i < selection.length; i++) {
                var entity = selection[i];
                if (entity instanceof ArrangementObject && SceneConstants.ArrangementType.switchCustomizableArrangements.indexOf(entity.objectType) !== -1) {
                    continue;
                }
                if (entity instanceof ArrangementGroup) {
                    entity = EntityFactory.getInstance().cloneEntity(entity, false)!;
                    var arrangementList = (entity as any).arrangementObjectsRec;
                    for (var j = 0 ; j < arrangementList.length ; j++) {
                        if (SceneConstants.ArrangementType.switchCustomizableArrangements.indexOf(arrangementList[j].objectType) !== -1) {
                            var parent = arrangementList[j].parent;
                            parent.deleteChild(arrangementList[j].id);
                            while(parent.isArrangementGroupEntity()) {
                                parent.recenter();
                                parent = parent.parent;
                            }
                        }
                    }
                }
                if (oneWritten) {
                    json += ',';
                }
                json += JSON.stringify(JSONSerializer._serializeEntity(entity, [], [], []));
                oneWritten = true;
            }
            json += ']';

            var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
            var downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = 'deliverable_selectionwithoutswitch_' + this.planId + '.rhinovselection';
            downloadLink.click();
        }
    };

    importRhinovFormatSelection() {
        (document.getElementById('format-rhinovselection-pick') as HTMLInputElement).value = '';
        document.getElementById('format-rhinovselection-pick')!.click();
    };

    updateIds(entityJSON: any) {
        EntityFactory.getInstance().incLastEntityId();
        entityJSON.id = EntityFactory.getInstance().getLastEntityId();

        for (var i = 0; i < entityJSON.children.length; i++) {
            this.updateIds(entityJSON.children[i]);
        }
    };

    CheckSelectionUploaded(newValue: File) {
        if (newValue !== null) {
            var r = new FileReader();
            r.onload = (e: any) => {
                var selectionJSON = JSON.parse(e.target.result);

                for (var i = 0; i < selectionJSON.length; i++) {
                    this.updateIds(selectionJSON[i]);

                    var arr = JSONImporter.importEntity(selectionJSON[i], PlanManager.getInstance().world.currentScene!.currentFloor);
                    if (arr.isArrangementGroupEntity()) {
                        arr.recenter();
                    }

                    EntityManager.getInstance().addEntity(arr);

                    KitchenTool.KitchenManager.setFurnitureFinishes(PlanManager.getInstance().world.currentScene!.currentFloor);

                    // Inform WebGL to update this object by adding it back to the scene
                    eventsManager.instance.dispatch(Events.COMMAND_EXECUTED,
                        {
                            name: Commands.CommandEnum.AddEntityCommand,
                            undo: false,
                            datas: {
                                id: arr.id,
                                type: arr.entityType,
                                entity: arr
                            }
                        });
                }
                // Then save in cache
                PlanManager.getInstance().saveInCache();
            };
            r.readAsText(newValue);
        }
    };

    repositionEntities(tree: any, height: number) {
        if (tree.entityType === SceneConstants.EntityType.Joinery) {
            tree.transform.localMatrix[14] = -height;
        }

        for (var i = 0; i < tree.children.length; i++) {
            this.repositionEntities(tree.children[i], height);
        }
    };

    renumberIDs(tree: any): number {
        var i: number;
        var baseID = EntityFactory.getInstance().getLastEntityId();
        var maxId: number;

        tree.id += baseID;
        maxId = tree.id;

        if (tree.entityType === SceneConstants.EntityType.Room) {
            for (i = 0; i < tree.walls.length; i++) {
                tree.walls[i] += baseID;
            }

            for (i = 0; i < tree.nonRoomedWalls.length; i++) {
                tree.nonRoomedWalls[i] += baseID;
            }
        }

        if (tree.entityType === SceneConstants.EntityType.Joinery) {
            maxId = maxId;
        }

        for (i = 0; i < tree.children.length; i++) {
            var childMaxId;

            childMaxId = this.renumberIDs(tree.children[i]);
            if (childMaxId > maxId) {
                maxId = childMaxId;
            }
        }

        return (maxId);
    }

    //Watch if a file has been selected in the hidden file picker


    CheckFloorUploaded(newValue: File, floorToImportId: number) {
        if (newValue !== null) {
            var r = new FileReader();
            r.onload = (e: any) => {
                //Export format and download it
                var floorIdx = -1;
                for (var i = 0; i < PlanManager.getInstance().world.currentScene!.floors.length; i++) {
                    if (PlanManager.getInstance().world.currentScene!.floors[i].id === floorToImportId) {
                        floorIdx = i;
                        break;
                    }
                }

                if (floorIdx === -1) {
                    return;
                }

                var floorJSON = JSON.parse(e.target.result);

                EntityFactory.getInstance().setLastEntityId(this.renumberIDs(floorJSON));

                var oldFloor = PlanManager.getInstance().world.currentScene!.floors[floorIdx];

                this.repositionEntities(floorJSON, oldFloor.height);

                floorJSON.transform.localMatrix[14] = oldFloor.height;
                var floor = JSONImporter.importFloor(floorJSON) as any;

                floor.floorName = (oldFloor as any).floorName;
                floor.hideDelete = (oldFloor as any).hideDelete;

                PlanManager.getInstance().world.currentScene!.addChild(floor);
                PlanManager.getInstance().CreateNewFloorFromImport(floor.id);

                // This is odd but no other choice, we have to go to the new floor without loading the floor underneath
                PlanManager.getInstance().setCurrentFloorByIndex(floor.id, false, false);
                // Then delete the old floor
                PlanManager.getInstance().world.currentScene!.deleteFloor(oldFloor.id);
                // Then finally go again to the new floor loading the floor underneath
                PlanManager.getInstance().setCurrentFloorByIndex(floor.id, false, true);

                KitchenTool.KitchenManager.setFurnitureFinishes(PlanManager.getInstance().world.currentScene!.currentFloor);
                // Then save in cache
                PlanManager.getInstance().saveInCache();
            };
            r.readAsText(newValue);
        }
    };

    /**
        * Reset orgin
        */
    resizeCallback() {
        let element = document.getElementById('FloatBarContainer');
        if (!element) return;
        var parent = element.parentElement;
        //Adapt position to parent height
        var topPosition = (parent!.clientHeight - element.clientHeight) * 0.33;
        element.style.top = (topPosition > 0 ? topPosition : 0) + 'px';
    };

    
    /**
        * on destroy event
        */
    Destroy() {
        eventsManager.instance.removeListener(this.actionCountList!);
        eventsManager.instance.removeListener(this.actionSaveScene!);
        eventsManager.instance.removeListener(this.didLoadListener!);
        eventsManager.instance.removeListener(this.cameraResizedListener!);
        eventsManager.instance.removeListener(this.fullscreenListener!);
    };

}